import { NSCheckbox } from 'bricks';
import React from 'react';
import { IDealDocument } from 'views/DocumentLibrary/types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IDocumentLibraryReportAsset } from './types';

export interface ISelectDocumentRowProps {
    document: IDealDocument,
    id: number
    selectedDocuments:IDocumentLibraryReportAsset[],
    handleToggleDocument: (event: React.ChangeEvent<HTMLInputElement>, docId: number, docName: string, docUrl: string) => void;

}
const SelectDocumentRow = ({
    document, selectedDocuments, handleToggleDocument, id,
} : ISelectDocumentRowProps) => {
    const { name, s3Url } = document;
    const {
        attributes, listeners, setNodeRef, transform, transition,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <tr
            ref={setNodeRef}
            key={`document-row-${document.id}`}
            style={style}
            className="font-weight-bold"
        >
            <td
                {...attributes}
                {...listeners}
                className="col-11 text-truncate cursor--grab"
            >
                <span>{name}</span>
            </td>
            <td>
                <NSCheckbox
                    id={`doc-${id}`}
                    checked={selectedDocuments.find(selectedDoc => selectedDoc.id === id)?.checked || false}
                    callback={(event: React.ChangeEvent<HTMLInputElement>) => {
                        event.stopPropagation();
                        handleToggleDocument(event, id, name, s3Url);
                    }}
                    labelClassName="font-weight-normal text-white"
                />
            </td>
        </tr>
    );
};

export default SelectDocumentRow;
